import React from "react";

import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import { useDispatch } from "react-redux";
import { getProducts } from "@/fetch/fetchStatistics";

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import _ from "lodash";
export function ProductSelection(props) {
  const dispatch = useDispatch();
  const {
    selectedBrand,
    combineSameSku,
    selectedProduct,
    setSelectedBrand,
    setSelectedProduct,
    setCombineSameSku,
    productData,
    width = 400,
  } = props;
  const [brandOptions, setBrandOptions] = React.useState([]);
  const [productOptions, setProductOptions] = React.useState([]);
  const inputRef = React.useRef(null);
  const [searchText, setSearchText] = React.useState("");
  const handleCombineChange = () => {
    dispatch(setCombineSameSku());
  };
  const handleBrandChange = (event) => {
    if (_.includes(event.target.value, "ALL")) {
      if (event.target.value.length === brandOptions.length + 1) {
        dispatch(setSelectedBrand({ value: [] }));
        dispatch(setSelectedProduct({ value: [] }));
      } else {
        dispatch(setSelectedBrand({ value: _.map(brandOptions, "brand_id") }));
        dispatch(setSelectedProduct({ value: _.map(productOptions, "id") }));
      }
    } else {
      dispatch(setSelectedBrand({ value: event.target.value }));
      const filterByBrand = _.filter(productOptions, (o) =>
        _.includes(event.target.value, o.brand_id)
      );
      dispatch(setSelectedProduct({ value: _.map(filterByBrand, "id") }));
    }
  };
  const handleProductChange = (event) => {
    if (_.includes(event.target.value, "ALL")) {
      const filterByBrand = _.filter(
        productOptions,
        (o) =>
          _.includes(selectedBrand, o.brand_id) &&
          (o.m18_product_code.toLowerCase().indexOf(searchText.toLowerCase()) >
            -1 ||
            o.product_name.toLowerCase().indexOf(searchText.toLowerCase()) > -1)
      );
      if (event.target.value.length === filterByBrand.length + 1) {
        dispatch(setSelectedProduct({ value: [] }));
      } else {
        dispatch(setSelectedProduct({ value: _.map(filterByBrand, "id") }));
      }
    } else {
      dispatch(setSelectedProduct({ value: event.target.value }));
    }
  };

  function makeItems(data) {
    const groupByBrand = _.groupBy(data, "brand_name");
    const items = [];
    _.forEach(groupByBrand, (values, brand) => {
      items.push(
        <ListSubheader style={{ zIndex: 0 }} key={brand}>
          <IconButton
            onClick={() => {
              let concatValue = [];
              const isExisting = data.find(
                (d) => d.brand_name === brand && selectedProduct.includes(d.id)
              );
              if (isExisting) {
                const currentValues = productOptions.filter((options) =>
                  selectedProduct.includes(options.product_master_id)
                );
                concatValue = _.map(
                  _.filter(currentValues, (d) => d.brand_name !== brand),
                  "product_master_id"
                );
              } else {
                const options = _.filter(
                  productOptions,
                  (s) => s.brand_name === brand
                );

                concatValue = _.concat(
                  selectedProduct,
                  _.map(options, "product_master_id")
                );
              }
              dispatch(setSelectedProduct({ value: concatValue }));
            }}
          >
            {brand}
          </IconButton>
        </ListSubheader>
      );
      _.forEach(values, (value, index) => {
        items.push(
          <MenuItem key={value.id} value={value.id}>
            <Checkbox
              checked={
                selectedProduct.find((d) => d === value.id) !== undefined
              }
            />
            {`${value.m18_product_code} - ${value.product_name}  ${
              value.region_id !== 1 ? `(${value.region_name})` : ""
            } `}
          </MenuItem>
        );
      });
    });
    return items;
  }
  const fetchProduct = async () => {
    const uniqByBrand = _.uniqBy(productData, "brand_id");
    setBrandOptions(uniqByBrand);
    if (selectedBrand.length === 0) {
      dispatch(setSelectedBrand({ value: _.map(uniqByBrand, "brand_id") }));
    }
    setProductOptions(productData);
    if (selectedProduct.length === 0) {
      dispatch(setSelectedProduct({ value: _.map(productData, "id") }));
    }
  };

  React.useEffect(() => {
    fetchProduct();
  }, []);
  return (
    <React.Fragment>
      <FormControl sx={{ m: 1, width: width / 2 }}>
        <InputLabel id="brand-select-label">品牌</InputLabel>
        <Select
          MenuProps={{ autoFocus: false }}
          labelId="brand-select-label"
          id="brand-select"
          value={selectedBrand}
          label="brand"
          multiple
          onChange={handleBrandChange}
          renderValue={(selected) =>
            selected.length === brandOptions.length
              ? "所有品牌"
              : `已選擇${selected.length}個`
          }
          input={<OutlinedInput label="品牌" />}
        >
          <MenuItem key={"ALL"} value={"ALL"}>
            <Checkbox checked={selectedBrand.length === brandOptions.length} />
            <ListItemText primary={"所有品牌"} />
          </MenuItem>
          {_.map(brandOptions, (item, index) => (
            <MenuItem key={index} value={item.brand_id}>
              <Checkbox
                checked={
                  selectedBrand.find((d) => d === item.brand_id) !== undefined
                }
              />
              <ListItemText primary={item.brand_name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ m: 1, width: width / 2 }}>
        <InputLabel id="brand-select-label">產品</InputLabel>
        <Select
          MenuProps={{ autoFocus: false }}
          labelId="product-select-label"
          id="product-select"
          value={selectedProduct}
          label="product"
          multiple
          onChange={handleProductChange}
          renderValue={(selected) =>
            selected.length === productOptions.length
              ? "所有產品"
              : `已選擇${selected.length}個`
          }
          onClose={() => setSearchText("")}
          input={<OutlinedInput label="產品" />}
        >
          <ListSubheader
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1,
            }}
          >
            <TextField
              sx={{ width: 600 }}
              style={{
                backgroundColor: "white",
              }}
              autoFocus
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end" onClick={() => setSearchText("")}>
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              ref={inputRef}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          <MenuItem
            key={"ALL"}
            value={"ALL"}
            style={{
              position: "sticky",
              top: 56,
              backgroundColor: "white",
              zIndex: 1,
            }}
          >
            <Checkbox
              checked={
                selectedProduct.length ===
                _.filter(productOptions, (o) =>
                  _.includes(selectedBrand, o.brand_id)
                ).length
              }
            />
            <ListItemText primary={"所有產品"} />
          </MenuItem>
          {makeItems(
            _.filter(
              productOptions,
              (o) =>
                _.includes(selectedBrand, o.brand_id) &&
                (o.m18_product_code
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) > -1 ||
                  o.product_name
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1)
            )
          )}
        </Select>
        {combineSameSku !== undefined && (
          <FormControlLabel
            control={
              <Checkbox
                checked={combineSameSku}
                onChange={handleCombineChange}
              />
            }
            label="組合相同SKU"
          />
        )}
      </FormControl>
    </React.Fragment>
  );
}
